/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	// パラメータ格納関数
	const pArray = () => {
		let urlParam = location.search.substring(1);
		let paramArray = [];
		if(urlParam) {
			let param = urlParam.split('&');
			for(let i = 0; i < param.length; i++) {
				let paramItem = param[i].split('=');
				paramArray[paramItem[0]] = paramItem[1];
			}
		}
		return paramArray;
	};
	// URLからニュースIDを取得
	const getNewsID = () => {
		return location.pathname.split('/').slice(-1)[0].split('.')[0];
	}
	// カテゴリを取得
	const getCategory = () => {
		return $('.rt_category_code').text();
	}
	// ニューストピック設定
	const setPurposeNews = () => {
		const newsID = getNewsID();
		const category = getCategory();
		const newsBlock = $('.js-news_block');
		// JSONデータ取得
		const getJSONNews = () => {
			let JSONURL = ''
			const pagePath = location.pathname;
			if (pagePath.indexOf('/ja/') != -1) {
				JSONURL = '/ja/ajax/purpose/sustainable_world/detail/'+category+'/'+newsID+'.json';
			}else if (pagePath.indexOf('/en/') != -1) {
				JSONURL = '/en/ajax/purpose/sustainable_world/detail/'+category+'/'+newsID+'.json';
			}
			return $.getJSON(JSONURL);
		};
		// ニューストピック生成
		getJSONNews().then((data) => {
			const NewsData = data.rt_bn_news_division_list_sustainbable;
			console.log(NewsData);
			//カテゴリ部の生成
			const getCategoryNameElem = (num) => {
				let newsCategoryNameElem = ''
				for (let j = 0; j < NewsData[num].rt_cf_n_category_name.content.length; j++) {
					newsCategoryNameElem += '<p class="mod-news_box-category">'+ NewsData[num].rt_cf_n_category_name.content[j] +'</p>';					
				}
				return newsCategoryNameElem;
			}
			//タイトル部の生成
			const getTitleElem = (num) => {
				let newsTitleElem = ''
				for (let j = 0; j < NewsData[num].rt_cf_n_title.content.length; j++) {
					if (NewsData[num].rt_cf_n_title.content[j].tag === 'br') {
						newsTitleElem += '<br>';
					}else if (NewsData[num].rt_cf_n_title.content[j].tag) {
						newsTitleElem += '<'+ NewsData[num].rt_cf_n_title.content[j].tag +'>';
						newsTitleElem += NewsData[num].rt_cf_n_title.content[j].content;
						newsTitleElem += '</'+ NewsData[num].rt_cf_n_title.content[j].tag +'>';
					} else {
						newsTitleElem += NewsData[num].rt_cf_n_title.content[j];
					}
				}
				return newsTitleElem;
			}
			//NEWアイコン部の生成
			const setNewIcon = (num) => {
				if(NewsData[num].rt_cf_n_icon_new){
					return '<span class="mod-new_icon">NEW</span>'
				}else {
					return ''
				}
			} 
			//タグ部の生成
			const getTagElem = (num) => {
				let newsTagElemElem = ''
				if (NewsData[num].cf_n_tags !== null) {
					for (let j = 0; j < NewsData[num].cf_n_tags.length; j++) {
						newsTagElemElem += '<a href="'+ NewsData[num].cf_n_tags[j].rt_cf_n_tag_hashtag.href +'" class="mod-tag">'+ NewsData[num].cf_n_tags[j].rt_cf_n_tag_hashtag.content +'</a>';					
					}
					return newsTagElemElem;
				}else {
					return "";
				}
			}
			// hrefのデータを取得（undefindを""に置き換える）
			const getHrefData = (data) => {
				let dataArr = new Array(4)
				dataArr[0] = data.href
				const key = ['target' , 'class' , 'style']
				for (let i = 1; i < dataArr.length; i++) {
					if (data[key[i-1]]) {
						dataArr[i] = data[key[i-1]]
					} else {
						dataArr[i] = ""
					}
				}
				return dataArr
			}
			if (NewsData.length === 0) {
				newsBlock.parents('section').css('display', 'none')
			} else {
				let newsElem = ''
				for (let i = 0; i < NewsData.length; i++) {
					newsElem += '<li class="mod-news_box">'
					const hrefData = getHrefData(NewsData[i].rt_cf_n_href)
					newsElem += '<a href="' + hrefData[0] + '" target="' + hrefData[1] + '" class="mod-news_box-a ' + hrefData[2] + '" style="'+ hrefData[3] +'">'
					newsElem += '<figure class="mod-news_box-img">'
					newsElem += '<img src="'+ NewsData[i].rt_cf_n_img.src +'" alt="'+ NewsData[i].rt_cf_n_img.alt +'">'
					newsElem += '</figure>'
					newsElem += getCategoryNameElem(i)
					newsElem += '<h2 class="mod-news_box-title">'
					newsElem += getTitleElem(i)
					newsElem += setNewIcon(i)
					newsElem += '</h2></a>'
					newsElem += '<div class="mod-news_box-bottom">'
					newsElem += '<span class="mod-news_box-day">'+ NewsData[i].rt_cf_n_date.content +'</span>'
					newsElem += getTagElem(i);
					newsElem += '</div></li>'
				}
				newsBlock.empty();
				newsBlock.append(newsElem)
			}
		});
	}
	setPurposeNews()
})(window.jQuery, window.FUNCTIONS);